import axios from 'axios';
import { api } from '@/api';

export default {
  checkLogin({ commit, dispatch }, setConfigAccess = true) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/get-user`).then(
        res => {
          commit('updateBuildNumber', res.headers['build-no']);

          if (Object.keys(res.data).length === 0) {
            commit('updateUserAuth', null);
            commit('updateUserInfo', null);
          } else {
            commit('updateUserAuth', res.data);
            commit('updateUserInfo', res.data);

            if (setConfigAccess) {
              dispatch('setConfigAccess');
            }
          }

          resolve(res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  setConfigAccess({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/rbac/access-config`).then(
        res => {
          resolve(res.data);
          commit(
            'account/updateNavigation',
            {
              access: res.data,
              user: state.userInfo,
            },
            { root: true },
          );
          commit('updateConfigAccess', res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  setConfig({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/config`).then(
        res => {
          resolve(res.data);
          if (params.hide) {
            commit('updateConfig', {
              ...res.data,
              hide: true,
            });
          } else {
            commit('updateConfig', res.data);
          }
        },
        error => {
          reject(error);
        },
      );
    });
  },

  setUserInfoDealer({ commit }, { data, type, units, currency }) {
    commit('common/updatePreload', '', { root: true });
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/update`, data).then(
        res => {
          resolve(res.data);
          commit('updateUserInfoDealer', {
            data: data,
            type: type,
            units: units,
            currency: currency,
          });
          commit('common/updatePreload', '', { root: true });
        },
        error => {
          reject(error);
          commit('common/updatePreload', '', { root: true });
        },
      );
    });
  },

  setCurrencies({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/currencies`).then(
        res => {
          resolve(res.data);
          commit('updateCurrencies', res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  setCompanies({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/companies`).then(
        res => {
          resolve(res.data);
          commit('updateCompanies', res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  userInfoProductionSet({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      const value = () => {
        if (state.userInfo.dealer.has_production == 0) {
          return 1;
        }
        return 0;
      };
      axios
        .post(`${process.env.VUE_APP_API_URL}/api/dealers/production/update-has-production`, {
          value: value(),
        })
        .then(
          res => {
            resolve(res.data);
            dispatch('checkLogin');
            /*commit('userInfoProductionUpdate', value());*/
          },
          error => {
            reject(error);
          },
        );
    });
  },

  userInfoWarehouseSet({ commit, state }, val) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.VUE_APP_API_URL}/api/dealers/production/update-has-warehouse`, {
          value: val,
        })
        .then(
          res => {
            resolve(res.data);
          },
          error => {
            reject(error);
          },
        );
    });
  },

  userInfoMaxZgiSet({ commit, state }, { count }) {
    commit('common/updatePreload', '', { root: true });
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.VUE_APP_API_URL}/api/dealers/production/update-max-zgi`, {
          count: count,
        })
        .then(
          res => {
            resolve(res.data);
            commit('userInfoMaxZgiUpdate', count);
          },
          error => {
            reject(error);
          },
        )
        .finally(() => {
          commit('common/updatePreload', '', { root: true });
        });
    });
  },

  userInfoMaxCutSet({ commit }, { count }) {
    commit('common/updatePreload', '', { root: true });
    return new Promise((resolve, reject) => {
      api.methods.dealers.production.updateMaxCut
        .post({ count })
        .then(
          res => {
            resolve(res.data);
            commit('userInfoMaxCutUpdate', count);
          },
          error => {
            reject(error);
          },
        )
        .finally(() => {
          commit('common/updatePreload', '', { root: true });
        });
    });
  },
};
